<template>
  <div class="page-core">
    <!-- 视频播放容器 -->
    <div class="video_box">
      <div
        v-for="item in remoteUsersViews"
        :key="item"
        :id="item"
        class="tencent-webrtc-webview"
        style="width: 100%; height: 100%; border-radius: 31px"
      />
    </div>

    <!-- 隐藏-日志 -->
    <div class="page-section" v-if="false">
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-col :span="24">日志：</el-col>
      </el-row>
      <el-row :gutter="16" style="margin-bottom: 10px">
        <div class="log-container" ref="logContainer">
          <div v-for="(item, index) in logList" :key="index">
            <span class="log-state" v-if="item.type === 'success'">🟩 </span>
            <span class="log-state" v-if="item.type === 'failed'">🟥 </span>
            <span>{{ item.log }}</span>
          </div>
        </div>
      </el-row>
    </div>

    <!-- 隐藏-按钮 -->
    <router-link class="hiddenButton" to="/demo">前往Demo页</router-link>
  </div>
</template>

<script>
import TRTC from 'trtc-sdk-v5';
import LibGenerateTestUserSig from '@/utils/lib-generate-test-usersig.min.js';

export default {
  name: 'homePage',
  data() {
    return {
      // ---- trtc实例 -----
      trtc: null, // trtc实例
      // ---- 房间参数 -----
      roomState: {
        sdkAppId: 1600098115, // 必须是number类型
        sdkSecretKey:
          'b4175b3a6ac588851b783bbca5d4450c2bf4b723ac66def262e49bc8c7e66113',
        roomId: 0, // 必须是number类型
        userId: '',
        userSig: '',
      },
      roomStatus: 'exited', // exited, exiting, entering, entered
      camStatus: 'stopped', // stopped, starting, started, stopping
      micStatus: 'stopped', // stopped, starting, started, stopping
      shareStatus: 'stopped', // stopping, stopped, sharing, shared
      isMutedVideo: false,
      isMutedAudio: false,
      // ---- 日志 -----
      logList: [], // 日志列表
      // ---- 播放窗口 -----
      remoteUsersViews: [], // 远端用户列表
    };
  },
  async created() {
    // 从URL获取roomId和userId
    this.roomState.roomId = parseInt(this.$route.query.roomId) || 4567;
    this.roomState.userId = this.$route.query.userId || 'jiekee';
    console.log(`---- 获取到roomId -----`, this.roomState.roomId);
    console.log(`---- 获取到userId -----`, this.roomState.userId);

    // 调用接口生成userSig
    const userSig = await this.generateUserSig(this.roomState.userId);
    this.roomState.userSig = userSig;

    // 初始化trtc实例
    this.initTRTC();
    // 进入房间
    this.handle_enterRoom();
  },
  methods: {
    // ---- trtc实例相关方法 -----
    // 初始化trtc实例
    initTRTC() {
      if (this.trtc) return;
      this.trtc = TRTC.create();
      console.log(`---- 初始化trtc实例成功 -----`);
    },
    // 加入房间
    async enterRoom() {
      this.roomStatus = 'entering';
      this.initTRTC();
      try {
        await this.trtc.enterRoom({
          sdkAppId: parseInt(this.roomState.sdkAppId, 10),
          roomId: this.roomState.roomId,
          userId: this.roomState.userId,
          userSig: this.roomState.userSig,
        });
        this.roomStatus = 'entered';

        this.installEventHandlers();
        this.startGetAudioLevel();
        this.addSuccessLog(`Enter room [${this.roomId}] success.`);
      } catch (error) {
        this.roomStatus = 'exited';
        console.error('enterRoom room failed', error);
        this.addFailedLog(
          `Enter room ${this.roomId} failed, please check your params. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 退出房间
    async exitRoom() {
      if (this.roomStatus !== 'entered') {
        this.addFailedLog('The room has not been entered');
        return;
      }
      this.roomStatus = 'exiting';
      this.stopGetAudioLevel();

      try {
        await this.trtc.exitRoom();
        this.roomStatus = 'exited';
        this.remoteUsersViews = [];
        this.uninstallEventHandlers();

        this.addSuccessLog('Exit room success.');
      } catch (error) {
        this.roomStatus = 'entered';
        this.addFailedLog(`Exit room failed. Error: ${error.message}`);
        throw error;
      }

      if (this.micStatus === 'started') this.handleStopLocalAudio();
      if (this.camStatus === 'started') this.handleStopLocalVideo();
      if (this.shareStatus === 'shared') this.handleStopScreenShare();
    },
    // 禁相机
    async muteVideo() {
      try {
        await this.trtc.updateLocalVideo({ mute: true });
        this.isMutedVideo = true;
        this.addSuccessLog('Mute video success.');
      } catch (error) {
        this.addFailedLog(`Mute video error: ${error.message}`);
      }
    },
    // 禁音频
    async muteAudio() {
      try {
        await this.trtc.updateLocalAudio({ mute: true });
        this.isMutedAudio = true;
        this.addSuccessLog('Mute audio success.');
      } catch (error) {
        this.addFailedLog(`Mute audio error: ${error.message}`);
      }
    },
    // 开相机
    async unmuteVideo() {
      try {
        await this.trtc.updateLocalVideo({ mute: false });
        this.isMutedVideo = false;
        this.addSuccessLog('Unmute video success.');
      } catch (error) {
        this.addFailedLog(`Unmute video error: ${error.message}`);
      }
    },
    // 开音频
    async unmuteAudio() {
      try {
        await this.trtc.updateLocalAudio({ mute: false });
        this.isMutedAudio = false;
        this.addSuccessLog('Unmute audio success.');
      } catch (error) {
        this.addFailedLog(`Unmute audio error: ${error.message}`);
      }
    },
    // 开始获取音频
    startGetAudioLevel() {
      this.trtc.on(TRTC.EVENT.AUDIO_VOLUME, (event) => {
        event.result.forEach(({ userId, volume }) => {
          const isMe = userId === '';
          if (isMe) {
            console.log(`my volume: ${volume}`);
          } else {
            console.log(`user: ${userId} volume: ${volume}`);
          }
        });
      });
      this.trtc.enableAudioVolumeEvaluation(2000);
    },
    // 停止获取音频
    stopGetAudioLevel() {
      this.trtc && this.trtc.enableAudioVolumeEvaluation(-1);
    },
    // 注册事件监听
    installEventHandlers() {
      this.trtc.on(TRTC.EVENT.ERROR, this.handleError);
      this.trtc.on(TRTC.EVENT.KICKED_OUT, this.handleKickedOut);
      this.trtc.on(TRTC.EVENT.REMOTE_USER_ENTER, this.handleRemoteUserEnter);
      this.trtc.on(TRTC.EVENT.REMOTE_USER_EXIT, this.handleRemoteUserExit);
      this.trtc.on(
        TRTC.EVENT.REMOTE_VIDEO_AVAILABLE,
        this.handleRemoteVideoAvailable
      );
      this.trtc.on(
        TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE,
        this.handleRemoteVideoUnavailable
      );
      this.trtc.on(
        TRTC.EVENT.REMOTE_AUDIO_UNAVAILABLE,
        this.handleRemoteAudioUnavailable
      );
      this.trtc.on(
        TRTC.EVENT.REMOTE_AUDIO_AVAILABLE,
        this.handleRemoteAudioAvailable
      );
      this.trtc.on(
        TRTC.EVENT.SCREEN_SHARE_STOPPED,
        this.handleScreenShareStopped
      );
    },
    // 取消事件监听
    uninstallEventHandlers() {
      this.trtc.off(TRTC.EVENT.ERROR, this.handleError);
      this.trtc.off(TRTC.EVENT.KICKED_OUT, this.handleKickedOut);
      this.trtc.off(TRTC.EVENT.REMOTE_USER_ENTER, this.handleRemoteUserEnter);
      this.trtc.off(TRTC.EVENT.REMOTE_USER_EXIT, this.handleRemoteUserExit);
      this.trtc.off(
        TRTC.EVENT.REMOTE_VIDEO_AVAILABLE,
        this.handleRemoteVideoAvailable
      );
      this.trtc.off(
        TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE,
        this.handleRemoteVideoUnavailable
      );
      this.trtc.off(
        TRTC.EVENT.REMOTE_AUDIO_UNAVAILABLE,
        this.handleRemoteAudioUnavailable
      );
      this.trtc.off(
        TRTC.EVENT.REMOTE_AUDIO_AVAILABLE,
        this.handleRemoteAudioAvailable
      );
      this.trtc.off(
        TRTC.EVENT.SCREEN_SHARE_STOPPED,
        this.handleScreenShareStopped
      );
    },
    // 事件-错误事件
    handleError(error) {
      this.addFailedLog(`Local error: ${error.message}`);
      alert(error);
    },
    // 事件-退出事件
    async handleKickedOut(event) {
      this.addFailedLog(`User has been kicked out for ${event.reason}`);
      this.trtc = null;
      await this.exitRoom();
    },
    // 事件-远端用户进入事件
    handleRemoteUserEnter(event) {
      const { userId } = event;
      this.addSuccessLog(`Remote User [${userId}] entered`);
    },
    // 事件-远端用户退出事件
    handleRemoteUserExit(event) {
      this.addSuccessLog(`Remote User [${event.userId}] exit`);
    },
    // 事件-远端视频激活事件
    handleRemoteVideoAvailable(event) {
      const { userId, streamType } = event;
      try {
        this.addSuccessLog(`[${userId}] [${streamType}] video available`);
        if (streamType === TRTC.TYPE.STREAM_TYPE_MAIN) {
          this.remoteUsersViews.push(`${userId}_main`);
          this.$nextTick(async () => {
            await this.trtc.startRemoteVideo({
              userId,
              streamType,
              view: `${userId}_main`,
            });
          });
        } else {
          this.remoteUsersViews.push(`${userId}_screen`);
          this.$nextTick(async () => {
            await this.trtc.startRemoteVideo({
              userId,
              streamType,
              view: `${userId}_screen`,
            });
          });
        }
        this.addSuccessLog(`Play remote video success: [${userId}]`);
      } catch (error) {
        this.addFailedLog(
          `Play remote video failed: [${userId}], error: ${error.message}`
        );
      }
    },
    // 事件-远端视频取消激活事件
    handleRemoteVideoUnavailable(event) {
      this.addSuccessLog(
        `[${event.userId}] [${event.streamType}] video unavailable`
      );
      const { streamType } = event;
      this.trtc.stopRemoteVideo({ userId: event.userId, streamType });
      if (streamType === TRTC.TYPE.STREAM_TYPE_MAIN) {
        this.remoteUsersViews = this.remoteUsersViews.filter(
          (userId) => userId !== `${event.userId}_main`
        );
      } else {
        this.remoteUsersViews = this.remoteUsersViews.filter(
          (userId) => userId !== `${event.userId}_screen`
        );
      }
    },
    // 事件-远端音频激活事件
    handleRemoteAudioAvailable(event) {
      this.addSuccessLog(`[${event.userId}] audio available`);
    },
    // 事件-远端音频取消激活事件
    handleRemoteAudioUnavailable(event) {
      this.addSuccessLog(`[${event.userId}] audio unavailable`);
    },
    // 事件-取消屏幕共享事件
    handleScreenShareStopped() {
      this.shareStatus = 'stopped';
      this.addSuccessLog('Stop share screen success');
    },
    // ---- 操作按钮相关的事件处理 -----
    // 监听-加入房间
    async handle_enterRoom() {
      // 检测配置
      if (!this.roomState.sdkAppId || !this.roomState.sdkSecretKey) {
        alert('缺少 sdkAppId 或 sdkSecretKey');
        return;
      }
      if (!this.roomState.roomId || !this.roomState.userId) {
        alert('缺少 roomId 或 userId');
        return;
      }

      /* ---- 当前是调用接口从后台获取userSig，所以不需要这种临时获取userSig的方法获取userSig了 ----- */
      // 生成userSig
      // const userSigGenerator = new LibGenerateTestUserSig(
      //   this.roomState.sdkAppId,
      //   this.roomState.sdkSecretKey,
      //   604800
      // );
      // this.roomState.userSig = userSigGenerator.genTestUserSig(
      //   this.roomState.userId
      // );

      // 进入房间
      await this.enterRoom();
      // 打开本地音频
      // this.handleStartLocalAudio();
      // 打开本地视频
      // this.handleStartLocalVideo();
    },
    // 监听-退出房间
    async handle_leaveRoom() {
      await this.exitRoom();
    },
    // 监听-采集麦克风
    async handleStartLocalAudio() {
      this.micStatus = 'starting';
      this.initTRTC();
      try {
        await this.trtc.startLocalAudio({
          option: {
            microphoneId: this.profile.microphoneId,
          },
        });
        this.isMutedAudio = false;
        this.micStatus = 'started';
        this.addSuccessLog('Local audio started successfully');
      } catch (error) {
        this.micStatus = 'stopped';
        this.addFailedLog(
          `Local audio is failed to started. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 监听-终止采集麦克风
    async handleStopLocalAudio() {
      if (this.micStatus !== 'started') {
        this.addFailedLog('The audio has not been started');
        return;
      }
      this.micStatus = 'stopping';
      this.initTRTC();
      try {
        await this.trtc.stopLocalAudio();
        this.micStatus = 'stopped';
        this.addSuccessLog('Local audio stopped successfully');
      } catch (error) {
        this.micStatus = 'started';
        this.addFailedLog(
          `Local audio is failed to stopped. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 监听-采集摄像头
    async handleStartLocalVideo() {
      this.camStatus = 'starting';
      this.initTRTC();
      try {
        await this.trtc.startLocalVideo({
          view: 'local',
          option: {
            cameraId: this.profile.cameraId,
            profile: '1080p',
          },
        });
        this.camStatus = 'started';
        this.isMutedVideo = false;
        this.addSuccessLog('Local video started successfully');
      } catch (error) {
        this.camStatus = 'stopped';
        this.addFailedLog(
          `Local video is failed to started. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 监听-终止采集摄像头
    async handleStopLocalVideo() {
      if (this.camStatus !== 'started') {
        this.addFailedLog('The video has not been started');
        return;
      }
      this.camStatus = 'stopping';
      this.initTRTC();
      try {
        await this.trtc.stopLocalVideo();
        this.camStatus = 'stopped';
        this.addSuccessLog('Local audio stopped successfully');
      } catch (error) {
        this.camStatus = 'started';
        this.addFailedLog(
          `Local audio is failed to stopped. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 监听-开始屏幕共享
    async handleStartScreenShare() {
      if (!this.roomState.sdkAppId || !this.roomState.sdkSecretKey) {
        alert('请输入sdkAppId 和 sdkSecretKey');
        return;
      }
      this.shareStatus = 'sharing';
      try {
        await this.trtc.startScreenShare();
        this.shareStatus = 'shared';
        this.addSuccessLog('Start share screen success');
      } catch (error) {
        this.shareStatus = 'stopped';
        this.addFailedLog(`Start share error: ${error.message}`);
      }
    },
    // 监听-关闭屏幕共享
    async handleStopScreenShare() {
      if (this.shareStatus !== 'shared') {
        this.addFailedLog('The Share is not started');
        return;
      }
      this.shareStatus = 'stopping';
      try {
        await this.trtc.stopScreenShare();
        this.shareStatus = 'stopped';
        this.addSuccessLog('Stop share screen success');
      } catch (error) {
        this.shareStatus = 'shared';
        this.addFailedLog(`Stop share error: ${error.message}`);
      }
    },
    // ---- 日志相关的方法 -----
    // 新增成功的日志
    addSuccessLog(log) {
      this.logList.push({
        type: 'success',
        log,
      });
    },
    // 新增失败的日志
    addFailedLog(log) {
      this.logList.push({
        type: 'failed',
        log,
      });
    },
    // ---- 接口相关的方法 -----
    // 获取userSig
    async generateUserSig(userId) {
      const response = await fetch(
        // 测试环境：`http://ruoyi.html.test.jiekee.com/prod-api/tencentVideo/tencentTLSSigAPIv2?userId=${userId}`
        // 生产环境：`http://ruoyi.html.pre.jiekee.com/prod-api/tencentVideo/tencentTLSSigAPIv2?userId=${userId}`
        `http://ruoyi.html.pre.jiekee.com/prod-api/tencentVideo/tencentTLSSigAPIv2?userId=${userId}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        }
      );
      // 如果请求失败,报错
      if (!response.ok) {
        throw new Error('获取token失败');
      }
      // 有数据,返回userSig数据
      const data = await response.json();
      return data.data;
    },
  },
};
</script>

<style scoped>
/* 清除所有默认边距和滚动条 */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden; /* 隐藏滚动条 */
}
/* 全屏视频容器 */
.tencent-webrtc-webview {
  position: fixed; /* 或 absolute */
  top: 0;
  left: 0;
  width: 100vw; /* 视窗宽度 */
  height: 100vh; /* 视窗高度 */
  object-fit: cover; /* 填充整个容器（保持比例） */
  z-index: -1; /* 置于底层（如有其他内容） */
}
.tencent-webrtc-webview >>> video {
  border-radius: 31px;
}
/* 日志区域样式 */
.log-container {
  flex-grow: 1;
  border: 1px solid #dddddd;
  height: 360px;
  padding: 10px;
  margin-right: 16px;
  overflow-y: scroll;
}
.log-container .log-label {
  margin: 0 0 6px;
  font-weight: bold;
}
.log-container .log-state {
  display: inline-block;
  margin-right: 6px;
}
.log-container > div {
  font-size: 12px;
}
/* 普通的按钮 */
.button {
  width: 50px;
  height: 50px;
  border: none;
}
/* 隐藏的按钮 */
.hiddenButton {
  display: none;
  width: 0;
  height: 0;
  border: 0;
  padding: 0;
}
</style>
